"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EarlyLessonNarrative() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: photoRef,
    isVisible: photoVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: storyRef,
    isVisible: storyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section id="earlylessonnarrative" data-section-id="3374" className="relative overflow-hidden bg-background py-24 text-foreground lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headlineRef} className={`mx-auto mb-14 max-w-5xl text-center transition-all duration-700 ease-out lg:mb-20 ${headlineVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"} motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:transition-none`}>
          <div className="mb-5 flex items-center justify-center gap-4">
            <span aria-hidden="true" className="h-px w-10 bg-secondary" />

            <p className="text-xs font-medium uppercase tracking-[0.28em] text-muted-foreground">
              An Early Lesson
            </p>

            <span aria-hidden="true" className="h-px w-10 bg-secondary" />
          </div>

          <h2 className="font-serif text-4xl font-medium leading-[1.08] tracking-[-0.02em] text-primary md:text-5xl lg:text-[3.5rem]">
            A Ten-Minute Conversation That Stayed for Decades
          </h2>
        </div>

        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-20">
          <div ref={photoRef} className={`transition-all duration-700 ease-out lg:col-span-5 ${photoVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"} motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:transition-none`}>
            <figure className="overflow-hidden rounded-sm border border-border/60 bg-muted/20">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/law_office_interior.webp" alt="Professional law office interior in Hollywood, Florida" loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover" />
            </figure>
          </div>

          <div ref={storyRef} className={`transition-all delay-100 duration-700 ease-out lg:col-span-7 ${storyVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"} motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:transition-none`}>
            <div className="max-w-3xl">
              <div className="space-y-6 text-lg leading-8 text-foreground/80">
                <p>
                  Early in his career, Morrie I. Levine volunteered at a free
                  legal assistance day in Miami, speaking with people who might
                  not otherwise have had access to an attorney.
                </p>

                <p>
                  One woman arrived believing that no one could help her and
                  that no solution was available. After two brief
                  conversations, she returned to thank him with a hug.
                </p>
              </div>

              <blockquote className="my-10 border-l-2 border-secondary pl-7 md:my-12 md:pl-9">
                <p className="font-serif text-3xl italic leading-[1.25] tracking-[-0.01em] text-primary md:text-4xl">
                  “That experience has always stayed with me.”
                </p>
              </blockquote>

              <p className="text-lg leading-8 text-foreground/80">
                That moment remained with him. It reinforced a principle that
                has continued throughout his career: legal work begins with
                listening carefully, treating both the person and the problem
                with consideration, and making a genuine effort to determine
                what can be done.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}